import {DEFAULT_PRODUCTS_MAPPING, DEFAULT_TYPES} from "data/constants";

// `background` is deliberately absent: the app's own dynamic default (the
// gallery's current first background, GET /default-scenes/resolved) applies
// whenever the URL has no `background=` param — the same way a bare page
// load does. Baking a literal "1" here pinned every reset-to-defaults
// navigation to whatever used to be first, which went stale the moment a
// gallery was reordered (2026-10-11).
export const DEFAULT_PARAMS = {
  layout: 1,
};

/**
 * @param {string} channel
 * @param {string | null} [product] Defaults to the channel's declared product.
 * @param {string | null} [type] Defaults to the channel's declared content type.
 * @param {Record<string, string | number>} [params]
 * @returns {string} Path without a leading slash, e.g. `releases/IJ/eap?layout=1`.
 */
export function buildUrl(channel, product = null, type = null, params = DEFAULT_PARAMS) {
  const searchParams = new URLSearchParams(params);
  const productPath = product ?? DEFAULT_PRODUCTS_MAPPING[channel];
  const typePath = type ?? DEFAULT_TYPES[channel].value;

  return `${channel}/${productPath}/${typePath}?${searchParams.toString()}`;
}
